// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"604":"9b514b2e","830":"22e8c6f2","848":"cf5621cc","948":"99db3945"}[chunkId] + ".css";
};